import {
  gql,
  LazyQueryHookOptions,
  OperationVariables,
  useLazyQuery,
} from '@apollo/client';

interface GetUserTcAcceptanceResponse {
  getUserTcAcceptance: {
    body: {
      data: unknown;
      message: string;
      success: boolean;
    };
    status_code: number;
  };
}

export const GET_USER_TC_ACCEPTANCE = gql`
  query getUserTcAcceptance {
    getUserTcAcceptance {
      body {
        data
        message
        success
      }
      status_code
    }
  }
`;

export const useGetUserTcAcceptance = (
  options?: LazyQueryHookOptions<
    GetUserTcAcceptanceResponse,
    OperationVariables
  >,
) => {
  return useLazyQuery(GET_USER_TC_ACCEPTANCE, options);
};
